<template>
  <div v-if="billSelected !== {}">
    <div class="container" v-if="billSelected.cartItems.length <= 15">
      <div v-if="$route.query.state === 'in'" class="font_bold">
        CÔNG TY TNHH THƯƠNG MẠI CIE
      </div>
      <div v-if="$route.query.state === 'in'">
        Phòng 208, Tòa nhà Talico Số 22, Đường Hồ Giám, Phường Quốc Tử Giám,
        Quận Đống Đa, Thành phố Hà Nội, Việt Nam
      </div>
      <center>
        <div>
          <strong style="font-size: 20px">PHIẾU XUẤT KHO BÁN HÀNG</strong><br />
          Ngày:
          {{ date.getDate().toString().padStart(2, 0) }}
          tháng
          {{ (date.getMonth() + 1).toString().padStart(2, 0) }}
          năm {{ date.getFullYear().toString() }}
        </div>
        <div>Số: {{ billSelected.orderId }}</div>
      </center>
      <div style="margin-top: 10px">
        Tên người nhận hàng: {{ billSelected.receivedName }}
      </div>
      <div>Địa chỉ: {{ billSelected.receivedAddress }}</div>
      <div>Điện thoại: {{ billSelected.receivedPhone }}</div>
      <div>Mã NBH: {{ billSelected.salerCode }}</div>
      <div class="top-line">
        <table class="table">
          <tr id="table-product">
            <th class="cl1">STT</th>
            <th class="cl2">Mã hàng</th>
            <th class="cl3">Tên hàng</th>
            <th class="CTKM">CTKM</th>
            <th class="cl4">ĐVT</th>
            <th class="cl5">Số lượng</th>
            <th class="cl6">Đơn giá</th>
            <th class="cl7">Thành tiền</th>
          </tr>

          <tr v-for="(item, index) in billSelected.cartItems" :key="index">
            <td style="text-align: center">{{ index + 1 }}</td>
            <td>{{ item.productId }}</td>
            <td>{{ item.productName }}</td>
            <td>{{ item.promotion ? item.promotion[0] : "" }}</td>
            <td>{{ item.unit }}</td>
            <td style="text-align: right">{{ item.number }}</td>
            <td style="text-align: right" v-if="$route.query.state === 'in'">
              {{
                formatMoney(
                  Math.round(
                    item.productCost - item.discountAmount / item.number
                  )
                )
              }}
            </td>
            <td v-else></td>
            <td style="text-align: right" v-if="$route.query.state === 'in'">
              {{ formatMoney(Math.round(item.amount)) }}
            </td>
            <td v-else></td>
          </tr>

          <tr>
            <td colspan="4"><b>Cộng</b></td>
            <td></td>
            <td></td>
            <td></td>
            <td style="text-align: right" v-if="$route.query.state === 'in'">
              <b>{{ formatMoney(billSelected.amount) }}</b>
            </td>
            <td v-else></td>
          </tr>
          <tr>
            <td colspan="4">Tỷ lệ CK:</td>
            <td colspan="4">Số tiền chiết khấu:</td>
          </tr>
          <tr>
            <td colspan="4"></td>
            <td colspan="4">Cộng tiền hàng (Đã trừ CK)</td>
          </tr>
          <tr>
            <td colspan="4">
              Thuế suất GTGT:
              <span style="float: right">{{
                billSelected.vat * 100 + "%"
              }}</span>
            </td>
            <td colspan="4">
              Tiền thuế GTGT:
              <span style="float: right">{{
                formatMoney(billSelected.vatAmount)
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="4"></td>
            <td colspan="4">
              <b>Tổng tiền thanh toán</b>
              <span style="float: right">
                <b>{{ formatMoney(billSelected.amount) }}</b>
              </span>
            </td>
          </tr>
        </table>
      </div>
      <div style="margin-top: 10px">
        Số tiền viết bằng chữ:
        <b
          ><i>{{ this.billSelected.amount | read }}</i></b
        >
      </div>
      <div>Ghi chú: {{ billSelected.additionalInfo }}</div>
      <div>
        <div style="float: right; margin-right: 25pt">
          Ngày..... tháng..... năm.......
        </div>
      </div>
      <div class="bottom-bill">
        <div>
          <div><b>Người lập phiếu</b></div>
          <div>(Ký, họ tên)</div>
        </div>
        <div>
          <div><b>Người giao hàng</b></div>
          <div>(Ký, họ tên)</div>
        </div>
        <div>
          <div><b>Người nhận hàng</b></div>
          <div>(Ký, họ tên)</div>
        </div>
      </div>
    </div>
    <div v-if="billSelected.cartItems.length > 15">
      <div class="container">
        <div v-if="$route.query.state === 'in'" class="font_bold">
          CÔNG TY TNHH THƯƠNG MẠI CIE
        </div>
        <div v-if="$route.query.state === 'in'">
          Phòng 208, Tòa nhà Talico Số 22, Đường Hồ Giám, Phường Quốc Tử Giám,
          Quận Đống Đa, Thành phố Hà Nội, Việt Nam
        </div>
        <center>
          <div>
            <strong style="font-size: 20px">PHIẾU XUẤT KHO BÁN HÀNG</strong
            ><br />
            Ngày:
            {{ date.getDate().toString().padStart(2, 0) }}
            tháng
            {{ (date.getMonth() + 1).toString().padStart(2, 0) }}
            năm {{ date.getFullYear().toString() }}
          </div>
          <div>Số: {{ billSelected.orderId }}</div>
        </center>
        <div style="margin-top: 10px">
          Tên người nhận hàng: {{ billSelected.receivedName }}
        </div>
        <div>Địa chỉ: {{ billSelected.receivedAddress }}</div>
        <div>Điện thoại: {{ billSelected.receivedPhone }}</div>
        <div>Mã NBH: {{ billSelected.salerCode }}</div>
        <div class="top-line">
          <table class="table">
            <tr id="table-product">
              <th class="cl1">STT</th>
              <th class="cl2">Mã hàng</th>
              <th class="cl3">Tên hàng</th>
              <th class="CTKM">CTKM</th>
              <th class="cl4">ĐVT</th>
              <th class="cl5">Số lượng</th>
              <th class="cl6">Đơn giá</th>
              <th class="cl7">Thành tiền</th>
            </tr>

            <tr
              class="height_50"
              v-for="(item, index) in billSelected.cartItems.slice(0, 15)"
              :key="index"
            >
              <td style="text-align: center">{{ index + 1 }}</td>
              <td>{{ item.productId }}</td>
              <td>{{ item.productName }}</td>
              <td>{{ item.promotion ? item.promotion[0] : "" }}</td>
              <td>{{ item.unit }}</td>
              <td style="text-align: right">{{ item.number }}</td>
              <td style="text-align: right" v-if="$route.query.state === 'in'">
                {{
                  formatMoney(
                    Math.round(
                      item.productCost - item.discountAmount / item.number
                    )
                  )
                }}
              </td>
              <td v-else></td>
              <td style="text-align: right" v-if="$route.query.state === 'in'">
                {{ formatMoney(Math.round(item.amount)) }}
              </td>
              <td v-else></td>
            </tr>
          </table>
        </div>
      </div>

      <div class="container">
        <div class="top-line">
          <table class="table">
            <tr id="table-product">
              <th class="cl1">STT</th>
              <th class="cl2">Mã hàng</th>
              <th class="cl3">Tên hàng</th>
              <th class="CTKM">CTKM</th>
              <th class="cl4">ĐVT</th>
              <th class="cl5">Số lượng</th>
              <th class="cl6">Đơn giá</th>
              <th class="cl7">Thành tiền</th>
            </tr>
            <tr
              v-for="(item, index) in billSelected.cartItems.slice(15)"
              :key="index"
            >
              <td style="text-align: center">{{ index + 16 }}</td>
              <td>{{ item.productId }}</td>
              <td>{{ item.productName }}</td>
              <td>{{ item.promotion ? item.promotion[0] : "" }}</td>
              <td>{{ item.unit }}</td>
              <td style="text-align: right">{{ item.number }}</td>
              <td style="text-align: right" v-if="$route.query.state === 'in'">
                {{
                  formatMoney(
                    Math.round(
                      item.productCost - item.discountAmount / item.number
                    )
                  )
                }}
              </td>
              <td v-else></td>
              <td style="text-align: right" v-if="$route.query.state === 'in'">
                {{ formatMoney(Math.round(item.amount)) }}
              </td>
              <td v-else></td>
            </tr>

            <tr>
              <td colspan="4"><b>Cộng</b></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align: right" v-if="$route.query.state === 'in'">
                <b>{{ formatMoney(billSelected.amount) }}</b>
              </td>
              <td v-else></td>
            </tr>

            <tr>
              <td colspan="4">Tỷ lệ CK:</td>
              <td colspan="4">Số tiền chiết khấu:</td>
            </tr>
            <tr>
              <td colspan="4"></td>
              <td colspan="4">Cộng tiền hàng (Đã trừ CK)</td>
            </tr>
            <tr>
              <td colspan="4">
                Thuế suất GTGT:
                <span style="float: right">{{
                  billSelected.vat * 100 + "%"
                }}</span>
              </td>
              <td colspan="4">
                Tiền thuế GTGT:
                <span style="float: right">{{
                  formatMoney(billSelected.vatAmount)
                }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="4"></td>
              <td colspan="4">
                <b>Tổng tiền thanh toán</b>
                <span style="float: right">
                  <b>{{ formatMoney(billSelected.amount) }}</b>
                </span>
              </td>
            </tr>
          </table>
        </div>
        <div style="margin-top: 10px">
          Số tiền viết bằng chữ:
          <b
            ><i>{{ this.billSelected.amount | read }}</i></b
          >
        </div>
        <div>Ghi chú: {{ billSelected.additionalInfo }}</div>
        <div>
          <div style="float: right; margin-right: 25pt">
            Ngày..... tháng..... năm.......
          </div>
        </div>
        <div class="bottom-bill">
          <div>
            <div><b>Người lập phiếu</b></div>
            <div>(Ký, họ tên)</div>
          </div>
          <div>
            <div><b>Người giao hàng</b></div>
            <div>(Ký, họ tên)</div>
          </div>
          <div>
            <div><b>Người nhận hàng</b></div>
            <div>(Ký, họ tên)</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import read from "./convertNumberToString.js";
import firebase from "@/services/firebase-init.js";
export default {
  filters: { read },
  async created() {
    this.db = firebase.firestore();
    let bits = localStorage.getItem("bits");
    await this.db
      .collection(process.env.VUE_APP_ORDER + bits)
      .where("orderId", "==", parseInt(this.$route.query.orderId))
      .get()
      .then((doc) => {
        doc.forEach((item) => {
          this.billSelected = item.data();
        });
        this.billSelected.cartItems.forEach((element) => {
          this.amountExcludeTax += element.amount;
        });
      });
    this.print();
    console.log(parseInt(this.$route.query.orderId) + 10);
  },
  data() {
    return {
      billSelected: {},
      db: {},
      amountExcludeTax: 0,
      date: new Date(),
    };
  },
  methods: {
    print() {
      console.log("printing");
      setTimeout(() => {
        this.$nextTick(() => {
          window.print();
        });
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  color: black;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border: none;
  width: 595.4pt;
  font-family: "Times New Roman", Times, serif;
  padding: 10px 25px;
  font-size: 10pt;
  page-break-before: always;
}
.bottom-bill {
  display: flex;
  justify-content: space-around;
}
.bottom-bill > div {
  text-align: center;
}
.table {
  border-collapse: collapse;
}
table,
th,
td {
  border: 1px solid black;
  padding: 0px 5px 0 5px;
}

#table-product th {
  padding-top: 0px;
  padding-bottom: 0px;
  text-align: center;
  color: rgb(0, 0, 0);
}
.cl1 {
  width: 6%;
}
.cl2 {
  width: 15%;
}
.cl3 {
  width: 30%;
}
.CTKM {
  width: 15%;
}
center {
  border-bottom: rgb(172, 172, 172) solid 1px;
}
.top-line {
  padding-top: 15px;
  //border-top: solid 1px rgb(172, 172, 172);
  width: 100%;
  margin: auto;
}

.height_50 {
  height: 50px;
}

.font_bold {
  font-weight: bold;
}
</style>
